<template>
  <GwFilter
    :hasSaveBtn="false"
    :hasClearBtn="false"
    :hasUrlUpdate="false"
    filterUrlPrefix="ffrf"
    filterConfigKey="reportsFlopFilter"
    class="flex-1 d-flex reports-flop-filter"
  >
    <template #filterbody="{ filter, visibleFields, methods }">
      <div
        class="f-column"
        style="gap: 1rem"
      >
        <CheckboxRowNew
          v-for="field in getCheckboxRowItems(visibleFields)"
          :key="field.id"
          :item="field"
          @update="val => methods.handleUpdate({ field: field.field, values: val.selected })"
        >
          <template #default="{ item }">
            {{ field.getName(item) }}
          </template>
        </CheckboxRowNew>
      </div>
      <div
        class="f-column repflopfi_btn-save"
        style="gap: 0.25rem"
      >
        <GwTooltip
          class="mx-auto gw_hvr_content my-auto"
          :tooltip="$t('btn.save_filter')"
        >
          <template #opener>
            <div
              class="gw_btn"
              style="--height: 1.75rem"
              data-tst="rep_flop_filter_save_btn"
              @click="$emit('click:save'), methods.openSaveFilterDialog()"
            >
              <div class="mdi mdi-content-save clr-white f-center text-normal"></div>
            </div>
          </template>
        </GwTooltip>
        <GwSavedFiltersMenu
          class="mx-auto"
          filterUrlPrefix="ffrf"
          filterConfigKey="reportsFlopFilter"
          :isInside="savedFiltersInside"
          :hasUrlUpdate="false"
        >
        </GwSavedFiltersMenu>
      </div>
    </template>
  </GwFilter>
</template>

<script>
import GwSavedFiltersMenu from '@/components/DataTables/v2/GwSavedFiltersMenu'
import CheckboxRowNew from '@/components/Forms/CheckboxRowNew'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import GwTooltip from '@/components/lib/GwTooltip'

export default {
  name: 'ReportsFlopFilter',
  components: {
    GwSavedFiltersMenu,
    CheckboxRowNew,
    GwFilter,
    GwTooltip,
  },
  props: {
    savedFiltersInside: { default: () => false },
  },
  emits: ['click:save'],
  methods: {
    getCheckboxRowItems(visibleFields) {
      // console.log('visibleFields', visibleFields)
      const res = visibleFields.map(i => {
        const id = i.field_name
        const key = i.field_name
        const { options } = i
        const selected = i.values

        const p = this.options.find(o => o.id === id)
        const getName = p.nameFn || (val => val)

        const { isSingle } = p
        const hasAny = p.hasAny || !isSingle
        const style = isSingle ? '--clr-row-back: var(--clr-black-1-2)' : ''
        const { unit } = p
        const r = {
          field: i,
          title: i.title,

          id: key,
          title_tooltip: p.title_tooltip || null,
          hasDragSelect: this.mobile ? false : p.hasDragSelect || false,
          getName,
          style,
          options,
          selected,
          isSingle,
          hasAny,
          unit,
        }
        return r
      })
      // console.log(res)
      return res
    },
  },
  computed: {
    options() {
      const nameFn = i => this.$t(`practice.filter.${i.toLowerCase()}`)
      const res = [
        {
          id: 'flop_suits',
          nameFn,
        },
        {
          id: 'flop_paired',
          nameFn,
        },
        {
          id: 'flop_connectedness',
          nameFn,
        },
        {
          id: 'flop_subset',
          title_tooltip: this.$t('tooltips.board_subset'),
          isSingle: true,
          hasAny: true,
        },
        {
          id: 'flop_high_card',
          title_tooltip: this.$t(`practice.filter.flop_high_card_help`),
          hasDragSelect: true,
        },
        {
          id: 'flop_mid_card',
          hasDragSelect: true,
        },
        {
          id: 'flop_low_card',
          hasDragSelect: true,
        },
      ]
      return res
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>

<style lang="scss" scoped>
.repflopfi {
  display: flex;
  flex-direction: column;
  flex: 1;
  grid-gap: 1rem;
  position: relative;
  &_btn-save {
    position: absolute !important;
    top: 0.5rem;
    right: 0.5rem;
  }
}
</style>
